import { __decorate } from "tslib";
import { VuexModule, Module, Mutation, getModule } from 'vuex-module-decorators';
import store from '@blade/common/store';
let Control = class Control extends VuexModule {
    selectedDevicedArr = [];
    selectedDeviced = ['', '', '', ''];
    singleScreenIndex = 0;
    fourScreen = false;
    fullscreen = false;
    updateSelectedDevicedArr(data) {
        this.selectedDevicedArr = data;
    }
    updateSelectedDevice(data) {
        this.selectedDeviced = data;
    }
    updateSingleScreenIndex(data) {
        this.singleScreenIndex = data;
    }
    updateFourScreen(data) {
        this.fourScreen = data;
    }
    updateFullscreen(data) {
        this.fullscreen = data;
    }
};
__decorate([
    Mutation
], Control.prototype, "updateSelectedDevicedArr", null);
__decorate([
    Mutation
], Control.prototype, "updateSelectedDevice", null);
__decorate([
    Mutation
], Control.prototype, "updateSingleScreenIndex", null);
__decorate([
    Mutation
], Control.prototype, "updateFourScreen", null);
__decorate([
    Mutation
], Control.prototype, "updateFullscreen", null);
Control = __decorate([
    Module({ dynamic: true, store, name: 'senseXplorer/control' })
], Control);
export default getModule(Control);
